import instance from 'services/api';

export const uploadAttachments = (body) => instance.post('/upload', body).then(({ data: { data } }) => data);
export const unlinkImage = (image) => {
  return instance.post('/upload/unlink/', { imageId: image });
};
